<template
  ><v-dialog v-model="active" persistent width="500">
    <v-card>
      <v-card-title class="title" primary-title>Navigering i 3D </v-card-title>
      <v-card-text>
        <v-layout class="pl-3 pt-3" row align-center>
          <img width="40px" alt="Venstre museknapp" src="@/assets/mouse_left_button.svg" />
          <span
            >Panorer kartet ved å dra mens du holder inne venstre museknapp.
          </span>
        </v-layout>

        <v-layout class="pl-3 pt-3" row align-center>
          <img width="40px" alt="Høyre museknapp" src="@/assets/mouse_right_button.svg" />
          <span
            >Endre perspektiv ved å dra mens du holder inne høyre
            museknapp.</span
          >
        </v-layout>

        <v-layout class="pl-4 pt-3" row align-center>
          <span
            >Du kan bytte rundt funksjonene over ved hjelp av knappene
            <v-icon size="20">mdi-pan</v-icon> og
            <v-icon size="20">rotate_left</v-icon> nede til høyre i kartet. I 3D
            visning kan du ikke zoome til et rektangel ved å holde inne
            shift-tasten.</span
          >
        </v-layout>

        <v-checkbox
          class="pl-4 pt-3"
          v-model="hide3dNavigationHelpDialogNextTime"
          color="primary"
          label="Ikke vis denne meldingen neste gang."
        ></v-checkbox>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn flat @click="closeDialog">Lukk</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "MapViewModeTogglerHelpDialog",
  data: function() {
    return {
      hide3dNavigationHelpDialogNextTime: false,
      helpText: "",
      show3dNavigationHelpDialog: false,
      active: false
    };
  },
  watch: {
    is3d(newVal) {
      if (newVal && !this.hide3dNavigationHelpDialog) {
        this.active = true;
      }
    }
  },
  computed: {
    ...mapState(["hideWelcomeDialog", "is3d"]),
    hide3dNavigationHelpDialog: {
      set(hide3dNavigationHelpDialog) {
        this.setHide3dNavigationHelpDialog(hide3dNavigationHelpDialog);
      },
      get() {
        return this.$store.state.hide3dNavigationHelpDialog;
      }
    }
  },
  methods: {
    ...mapActions(["setHide3dNavigationHelpDialog"]),
    closeDialog: function() {
      if (this.hide3dNavigationHelpDialogNextTime) {
        localStorage.setItem(
          "hide3dNavigationHelpDialog",
          JSON.stringify(true)
        );
        this.hide3dNavigationHelpDialog = true;
      }
      this.active = false;
    }
  },
  mounted() {}
};
</script>

<style></style>
